import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Contact from './views/Contact.vue'
import AboutView from './views/AboutView.vue'

import ExchangeProgramView from './views/ExchangeProgramView.vue'
import FutherAducationView from './views/FutherAducationView.vue'
import Imprint from './views/Imprint.vue'
import PrivateDataPolicy from './views/PrivateDataPolicy.vue'
import TrrainingView from './views/TrrainingView.vue'
import NewsView from './views/NewsView.vue'

import HomeTest from './views/HomeTest.vue'
import ContactView from './views/ContactView.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/news',
      name: 'news',
      component: NewsView
    },
    {
      path: '/',
      name: 'home',
      component: HomeTest
    },
    { 
      path: '/contact', 
      name: 'contact',
      component: ContactView 
    },
    {
      path: '/about',
      name: 'about',
      component: AboutView
    },
    {
      path: '/programm',
      name: 'programm',
      component: ExchangeProgramView
    },
    {
      path: '/aducation',
      name: 'aducation',
      component: FutherAducationView
    },
    {
      path: '/imprint',
      name: 'imprint',
      component: Imprint
    },
    {
      path: '/policy',
      name: 'policy',
      component: PrivateDataPolicy
    },
    {
      path: '/trraining',
      name: 'trraining',
      component: TrrainingView
    },
    
  ]
})
